import React from 'react'
import PropTypes from 'prop-types'

const VideoEmbed = React.memo(({ className, title, videoId, width, height }) => {
  if (className)
    return (
      className && (
        <div className={`${className} testimonials-videos-section`}>
          <iframe
            width={width}
            height={height}
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={title}
          />
        </div>
      )
    )
  return (
    <iframe
      width={width}
      height={height}
      src={`https://www.youtube.com/embed/${videoId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={title}
    />
  )
})

VideoEmbed.propTypes = {
  videoId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

VideoEmbed.defaultProps = {
  className: '',
  width: '100%',
  height: '280',
}

export default VideoEmbed
